
/* ============================================================
   AV-95: Link nutrition images to their long descriptions
   Injected by Melinda's Accessibility Tool
   Updated: adds .a11y-nutrition-image class per UsableNet request
   ============================================================ */
(function() {
  'use strict';

  function isNutritionSrc(str) {
    return /nutri|nut[_\-]?panel|nut[_\-]?fact|supplement/i.test(str || '');
  }

  function linkNutritionImages() {
    var descElements = document.querySelectorAll('[id^="nutrition-desc-"]');
    if (descElements.length === 0) return;

    descElements.forEach(function(desc) {
      var images = document.querySelectorAll('img');
      images.forEach(function(img) {
        var src = (img.src || '');
        var alt = (img.alt || '');

        if (isNutritionSrc(src) || isNutritionSrc(alt)) {
          img.classList.add('a11y-nutrition-image');
          img.setAttribute('aria-describedby', desc.id);
          if (!img.alt || img.alt.trim() === '') {
            img.alt = 'Nutrition facts label';
          }
        }
      });
    });
  }

  // Run on initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', linkNutritionImages);
  } else {
    linkNutritionImages();
  }

  // Observe DOM for dynamically added images (PhotoSwipe lightbox, etc.)
  var observer = new MutationObserver(function(mutations) {
    var shouldRelink = false;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.tagName === 'IMG' && isNutritionSrc(node.src)) {
          shouldRelink = true; break;
        }
        if (node.querySelector) {
          var imgs = node.querySelectorAll('img');
          for (var k = 0; k < imgs.length; k++) {
            if (isNutritionSrc(imgs[k].src)) { shouldRelink = true; break; }
          }
        }
        if (shouldRelink) break;
      }
      if (shouldRelink) break;
    }
    if (shouldRelink) linkNutritionImages();
  });

  observer.observe(document.body || document.documentElement, {
    childList: true, subtree: true
  });
})();
